module.exports = __webpack_public_path__ + "static/scale-model-of-won't-you-be-my-neighbor-mural-in-austin-texas-a4133868cb1f0d4b9f6a3759f4adaca4.png";